import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "";

const AttendancePage = () => {
    const { postId } = useParams();
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!postId) return;

        const fetchAttendance = async () => {
            try {
                setError(null);
                const response = await fetch(`${API_URL}/get-attendance/${postId}/`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                });

                const result = await response.json();
                if (!response.ok) {
                    setData([]);
                    setError(result.error || result.detail || "Unable to load attendance");
                    console.error("Attendance fetch failed:", response.status, result);
                    return;
                }
                if (!Array.isArray(result)) {
                    setData([]);
                    setError(result.error || "Unexpected attendance response");
                    console.error("Unexpected attendance payload:", result);
                    return;
                }
                setData(result);
            } catch (err) {
                setData([]);
                setError("Network error while loading attendance");
                console.error("Attendance fetch error:", err);
            }
        };

        fetchAttendance();
    }, [postId]);

    return (
        <div>
            <h2>Attendance</h2>
            {error && <p style={{ color: "red" }}>{error}</p>}
            {!error && data.length === 0 && <p>No attendance records found.</p>}
            {data.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Join</th>
                            <th>Leave</th>
                            <th>Duration</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, i) => (
                            <tr key={i}>
                                <td>{row.user_name}</td>
                                <td>{row.join_time}</td>
                                <td>{row.leave_time || "Live"}</td>
                                <td>{row.duration_minutes}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AttendancePage;